export default {"src":"/_next/static/media/lunch-icon.d2713531.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};